// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2y8yh","title":"Images45_title__2u5xK","images":"Images45_images__1Tr06"};